import React, {Component} from 'react';

import Select from 'react-select';

import { comunasPorRegion } from './../utils/comunas';

const groupStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  };


  const formatGroupLabel = data => (
    <div style={groupStyles}>
      <span>{data.label}</span>
    </div>
  );

class SelectComunas extends Component {
    constructor(){
        super();
        this.state = {
            listado : [],
        }
    }
    
    render(){
        const {invalid} = this.props
        
        const customStyles = {
          control: (base, state) => ({
            ...base,
            padding:1,
            borderColor: state.isFocused ?
              '#ddd' : !invalid ?
              '#ddd' : 'red',
            '&:hover': {
              borderColor: state.isFocused ?
                '#ddd' : !invalid ?
                '#ddd' : 'red'
            }
          })
        }

        const {maneja, comuna} = this.props;
        return (
            <span>
                  <Select
                        styles={customStyles}
                        options={comunasPorRegion}
                        formatGroupLabel={formatGroupLabel}
                        value={comuna} 
                        onChange={maneja} 
                        isClearable={true} 
                        placeholder="Comuna"  
                        noOptionsMessage={() => "No se encontraron resultados"}
                    />

            </span>
        )
    }
};

export default SelectComunas;